import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { WebIntegrPerfilFuncADOService } from 'app/main/content/shared/services/webIntegrPerfilFuncADO.service';


@Component({
  selector: 'app-delete.dialog',
  templateUrl: '../../dialogs/delete/delete.dialog.html',
  styleUrls: ['../../dialogs/delete/delete.dialog.scss']
})
export class DeleteDialogMensagemFuncionalidadeComponent {

  constructor(public dialogRef: MatDialogRef<DeleteDialogMensagemFuncionalidadeComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, public webIntegrPerfilFuncADOService: WebIntegrPerfilFuncADOService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmDelete(): void {
    this.webIntegrPerfilFuncADOService.listDeleteData(this.data.idConfig);
  }
}